module.exports = __webpack_public_path__ + "img/8b95f65d672143e2b8db8ca0207d5b6a-1024.e7464b2d.jpg";